import React from 'react';
import PropTypes from 'prop-types';
import { Route } from "react-router-dom";
import UiUtils from '../../utils/UiUtils';
import TelefonosBusqueda from "./components/telefonos-busqueda/TelefonosBusqueda";
import { TELEFONOS_SEARCH_OPTIONS } from '../../config';
import SearchBarTelefonos from './components/SearchBarTelefonos';

class Telefonos extends React.Component {

  onBusquedaHandler = (tipo, valor) => {
    UiUtils.navigateTo(`/dashboard/Telefonos/busqueda/${tipo}/${valor}`);
  }

  onResultadoSeleccionado = (valor, isPerson) => {
    UiUtils.navigateTo(`/dashboard/${isPerson ? 'personas' : 'empresas'}/detalle/${valor}`);
  }

  render() {

    return (
      <div>
        <SearchBarTelefonos opciones={TELEFONOS_SEARCH_OPTIONS} onBusqueda={this.onBusquedaHandler} />
        <Route path={`${this.props.match.url}/busqueda/:tipo/:valor`} render={({ match }) => {
          return (
            <TelefonosBusqueda tipo={match.params.tipo} valor={match.params.valor}
              onResultadoSeleccionado={this.onResultadoSeleccionado} />
          )
        }} />
      </div>
    );
  }
}

Telefonos.propTypes = {
  match: PropTypes.object
}

export default Telefonos;



// WEBPACK FOOTER //
// ./src/scenes/telefonos/Telefonos.js